import React, { useEffect, useState } from "react";
import { Button, FormLabel, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
const MapSelections = ({
  platformData,
  setPlatformData,
  trackData,
  setTrackData,
  handleIsChanged,
  isChanged,
  refreshChange,
  triggerResetState,
}) => {
  const { t } = useTranslation("bplrtSmp");

  const innerloopPlatformId = [13, 15, 17, 19, 21, 23, 25];
  const innerloopTrackId = [6, 7, 8, 9, 10, 11, 12, 13];
  const outerloopPlatformId = [14, 16, 18, 20, 22, 24, 26];
  const outerloopTrackId = [19, 20, 21, 22, 23, 24, 25, 26];
  const inboundPlatformId = [2, 4, 6, 8, 10];
  const inboundTrackId = [1, 2, 3, 4, 5];
  const outboundPlatformId = [1, 3, 5, 7, 9];
  const outboundTrackId = [14, 15, 16, 17, 18];

  const [systemWideDisruption, setSystemWideDisruption] = useState(false);
  const [innerloopDisruption, setInnerloopDisruption] = useState(false);
  const [outerloopDisruption, setOuterloopDisruption] = useState(false);
  const [inboundDisruption, setInboundDisruption] = useState(false);
  const [outboundDisruption, setOutboundDisruption] = useState(false);

  const resetSelectionsState = () => {
    setInboundDisruption(false);
    setOutboundDisruption(false);
    setInnerloopDisruption(false);
    setOuterloopDisruption(false);
    setSystemWideDisruption(false);
  };

  useEffect(() => {
    resetSelectionsState();
  }, [triggerResetState]);

  const systemWideChangeDisruption = () => {
    const disrupted = !systemWideDisruption;
    const platformArr = platformData.map((data) => {
      data.isDisrupted = disrupted;
      return data;
    });
    const trackArr = trackData.map((data) => {
      data.isDisrupted = disrupted;
      return data;
    });
    setPlatformData(platformArr);
    setTrackData(trackArr);
    setSystemWideDisruption(disrupted);
    handleIsChanged();
  };

  const innerloopChangeDisruption = () => {
    const disrupted = !innerloopDisruption;
    const platformArr = platformData.map((data) => {
      if (innerloopPlatformId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    const trackArr = trackData.map((data) => {
      if (innerloopTrackId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    setPlatformData(platformArr);
    setTrackData(trackArr);
    setInnerloopDisruption(disrupted);
    handleIsChanged();
  };

  const outerloopChangeDisruption = () => {
    const disrupted = !outerloopDisruption;
    const platformArr = platformData.map((data) => {
      if (outerloopPlatformId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    const trackArr = trackData.map((data) => {
      if (outerloopTrackId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    setPlatformData(platformArr);
    setTrackData(trackArr);
    setOuterloopDisruption(disrupted);
    handleIsChanged();
  };

  const inboundChangeDisruption = () => {
    const disrupted = !inboundDisruption;
    const platformArr = platformData.map((data) => {
      if (inboundPlatformId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    const trackArr = trackData.map((data) => {
      if (inboundTrackId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    setPlatformData(platformArr);
    setTrackData(trackArr);
    setInboundDisruption(disrupted);
    handleIsChanged();
  };

  const outboundChangeDisruption = () => {
    const disrupted = !outboundDisruption;
    const platformArr = platformData.map((data) => {
      if (outboundPlatformId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    const trackArr = trackData.map((data) => {
      if (outboundTrackId.includes(data.id)) data.isDisrupted = disrupted;
      return data;
    });
    setPlatformData(platformArr);
    setTrackData(trackArr);
    setOutboundDisruption(disrupted);
    handleIsChanged();
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        border: 1,
        borderRadius: "4px",
        borderColor: "#9e9e9e",
      }}
    >
      <Grid item alignSelf="center">
        <FormLabel sx={{ fontSize: "12px", fontWeight: "bold" }}>
          {t("mapSelection.title")}
        </FormLabel>
      </Grid>
      <Grid item sx={{ mx: "8px", mt: "8px" }}>
        <Button
          variant="contained"
          onClick={() => {
            refreshChange();
          }}
          color="error"
          sx={{ boxShadow: 3, mr: "8px", mb: "8px" }}
          disabled={!isChanged}
        >
          {t("mapSelection.undo")}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            systemWideChangeDisruption();
          }}
          sx={{ boxShadow: 3, mr: "8px", mb: "8px" }}
        >
          {t("mapSelection.all")}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            innerloopChangeDisruption();
          }}
          sx={{ boxShadow: 3, mr: "8px", mb: "8px" }}
        >
          {t("mapSelection.innerLoop")}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            outerloopChangeDisruption();
          }}
          sx={{ boxShadow: 3, mr: "8px", mb: "8px" }}
        >
          {t("mapSelection.outerLoop")}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            inboundChangeDisruption();
          }}
          sx={{ boxShadow: 3, mr: "8px", mb: "8px" }}
        >
          {t("mapSelection.inbound")}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            outboundChangeDisruption();
          }}
          sx={{ boxShadow: 3, mb: "8px" }}
        >
          {t("mapSelection.outbound")}
        </Button>
      </Grid>
    </Grid>
  );
};

export default MapSelections;
